import { useComponentState } from "@faedev/dynamic-values";
import {
  composeClassNames,
  ifDefined,
  withDefault,
} from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import ModalContacts from "src/components/ModalContacts";
import Translate from "src/components/Translate";
import constants from "src/constants";
import translate from "src/functions/translate";
import { sButton } from "src/styles/sButton.module.scss";
import { sContactsInModal } from "src/styles/sContactsInModal.module.scss";
import { ApiContact } from "src/types/ApiContact";
import { VariantProfileType } from "src/types/VariantProfileType";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  data: {
    nickname: string;
    profileType: VariantProfileType;
    contacts: ApiContact[];
  };
};

const ContactsInModal = ({ style, className, data }: Props) => {
  var openModalContacts = useComponentState(false);
  const { locale: lang } = useRouter();
  return constants.Show.instructorContacts ? (
    <>
      {ifDefined(
        data,
        () => (
          <>
            {data.contacts[0] ? (
              data.contacts[0].type ? (
                <div
                  className={composeClassNames([
                    sContactsInModal,
                    className,
                    "btn-cta-wrapper",
                  ])}
                  style={style}
                >
                  <Button
                    variant="outline-primary"
                    className={composeClassNames([sButton, "btn-cta"])}
                    onClick={function () {
                      return openModalContacts.change(true);
                    }}
                  >
                    {
                      {
                        instructor: (
                          <Translate tKey={`Contact the instructor`} />
                        ),
                        studio: <Translate tKey={`Contact the studio`} />,
                        festival: <Translate tKey={`Contact the festival`} />,
                      }[data.profileType]
                    }
                  </Button>
                  <ModalContacts
                    openModalContacts={openModalContacts}
                    key={`ModalContacts`}
                    data={{
                      title: translate(`Contact`, lang) + ` ` + data.nickname,
                      profileType: withDefault(data.profileType, `instructor`),
                      contacts: data.contacts,
                    }}
                  />
                </div>
              ) : null
            ) : null}
          </>
        ),
        () => null
      )}
    </>
  ) : null;
};

export default ContactsInModal;
